'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Expression = require('./Expression');

var _Expression2 = _interopRequireDefault(_Expression);

var _Panel = require('calcite-react/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _Button = require('calcite-react/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Form = require('calcite-react/Form');

var _Tooltip = require('calcite-react/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _PlusIcon = require('../icons/PlusIcon');

var _PlusIcon2 = _interopRequireDefault(_PlusIcon);

var _SetStyled = require('./Set-styled');

var _CalciteThemeProvider = require('calcite-react/CalciteThemeProvider');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Set = function Set(props) {
  var addExpression = function addExpression() {
    props.addExpression(props.id);
  };

  var removeSet = function removeSet() {
    props.removeSet(props.id);
  };

  var updateSetOperator = function updateSetOperator(mustMatchAll) {
    props.updateSetOperator(props.id, mustMatchAll);
  };

  var handleRemoveExpression = function handleRemoveExpression(expressionId) {
    props.removeExpression(props.id, expressionId);
  };

  var handleUpdateExpression = function handleUpdateExpression(expression) {
    props.updateExpression(props.id, expression);
  };

  var getExpressions = function getExpressions(expressions) {
    return Object.keys(expressions).map(function (key) {
      var expression = expressions[key];
      return _react2.default.createElement(_Expression2.default, {
        key: key,
        id: key,
        disableUnique: props.disableUnique,
        expressionDef: expression,
        field: expression.field,
        fields: props.fields,
        updateExpression: handleUpdateExpression,
        removeExpression: handleRemoveExpression
      });
    });
  };

  return _react2.default.createElement(
    _Panel2.default,
    null,
    _react2.default.createElement(
      _SetStyled.StyledSetHeaderRow,
      null,
      _react2.default.createElement(
        _Form.FormControl,
        { horizontal: true, style: { marginBottom: '5px' } },
        _react2.default.createElement(
          _Form.FormControlLabel,
          { style: { marginRight: '10px' } },
          'Set Operator:'
        ),
        _react2.default.createElement(
          _Button.ButtonGroup,
          null,
          _react2.default.createElement(
            _Tooltip2.default,
            { title: 'All Expressions Match', enterDelay: 400 },
            _react2.default.createElement(
              _Button2.default,
              {
                extraSmall: true,
                clear: !props.mustMatchAll,
                onClick: function onClick() {
                  return updateSetOperator(true);
                }
              },
              'AND'
            )
          ),
          _react2.default.createElement(
            _Tooltip2.default,
            { title: 'Any Expressions Match', enterDelay: 400 },
            _react2.default.createElement(
              _Button2.default,
              {
                extraSmall: true,
                clear: props.mustMatchAll,
                onClick: function onClick() {
                  return updateSetOperator(false);
                }
              },
              'OR'
            )
          )
        )
      ),
      _react2.default.createElement(
        _Form.FormControl,
        { horizontal: true, style: { margin: 0 } },
        _react2.default.createElement(
          _Button2.default,
          { extraSmall: true, onClick: removeSet },
          'Remove Set'
        )
      )
    ),
    getExpressions(props.expressions),
    _react2.default.createElement(
      _SetStyled.StyledAddSetButton,
      { onClick: addExpression },
      _react2.default.createElement(_PlusIcon2.default, { fill: _CalciteThemeProvider.CalciteTheme.palette.gray }),
      ' Add Expression'
    )
  );
};

exports.default = Set;


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/containers/Set.js
// module id = 1470
// module chunks = 0